<template>
  <ListeMarche />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListeMarche from "@/components/Parametres/ListeMarche.vue";

export default defineComponent({
  name: "ListeMarchePage",
  components: {
    ListeMarche,
  },
});
</script>

